import React from 'react';
import { Outlet } from 'react-router-dom';

const OrdersClientsLayout: React.FC = () => {
  return <Outlet />;
};

export default OrdersClientsLayout;
